import { AI_REWRITE_TEXT_TRIGGER_ID } from 'src/js/modules/control-pane/constants/trigger-ids';
import contextMenu from 'src/js/modules/context-menu';

const isAiRewriteContextMenuVisible = () => {
  const { triggerId, visibility } = contextMenu.accessors.getMenu();

  return triggerId === AI_REWRITE_TEXT_TRIGGER_ID && visibility;
};

export default isAiRewriteContextMenuVisible;
